import React from 'react'
import { useField } from 'formik'
import { FormControl, MenuItem, Select } from '@mui/material'
import { FieldLabel } from '../FieldLabel/FieldLabel'
import { FieldError } from '../FieldError/FieldError'

export function FieldSelect({ name, label, required, ...props }) {
  const [field, meta] = useField(name)

  return (
    <FormControl className="field-container" fullWidth={ props.fullWidth }>
      {label && <FieldLabel required={required}>{label}</FieldLabel>}
      <Select {...props} {...field} sx={{ bgcolor: 'white' }}>
        { props.children }
      </Select>
      {!!meta.touched && !!meta.error && <FieldError>{meta.error}</FieldError>}
    </FormControl>
  )
}

FieldSelect.defaultProps = {
  label: '',
  required: false,
}
